module.exports = __webpack_public_path__ + "9e86fe95a02ebb28f7077abf92c8ffe2.png";